export const domain = 'creator.rezonence.com'
